import React, { FC } from 'react';
import { Theme, Svg } from 'styled';
import { Color } from 'styled/theme/colors';

type Props = {
  className?: string;
  color: Color;
};

const PinterestIcon: FC<Props> = ({ className = '', color = 'white' }) => (
  <Svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    className={className}
    fill="transparent"
  >
    <desc>Pinterest Icon.</desc>
    <path
      d="M27.5 14C27.5 21.4558 21.4558 27.5 14 27.5C6.54416 27.5 0.5 21.4558 0.5 14C0.5 6.54416 6.54416 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14Z"
      stroke={Theme.colors[color]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 13.9992C0 21.7306 6.26671 28 14 28C21.7318 28 28 21.7306 28 13.9992C28 6.26787 21.7318 0 14 0C6.26671 0 0 6.26787 0 13.9992ZM9.26154 26.1058C4.42629 24.2113 0.999983 19.5067 0.999983 14C0.999983 6.81858 6.8201 1 14 1C21.1799 1 27 6.81858 27 14C27 21.1799 21.1799 27 14 27C12.6587 27 11.3665 26.7972 10.1511 26.4192C10.6797 25.5557 11.4725 24.1406 11.766 23.0113C11.9242 22.4029 12.5757 19.9215 12.5757 19.9215C12.9997 20.7297 14.2381 21.415 15.5564 21.415C19.4759 21.415 22.3015 17.8089 22.3015 13.3286C22.3015 9.03416 18.7968 5.81988 14.2873 5.81988C8.67768 5.81988 5.69848 9.58728 5.69848 13.6881C5.69848 15.5933 6.71255 17.9687 8.33505 18.7246C8.58242 18.8383 8.71456 18.7876 8.77141 18.5495C8.78882 18.4767 8.83521 18.2885 8.89077 18.0632C8.97245 17.7319 9.07395 17.3201 9.13247 17.076C9.1632 16.9439 9.14784 16.8317 9.04182 16.7026C8.50406 16.0512 8.07539 14.8527 8.07539 13.7357C8.07539 10.8687 10.2464 8.09384 13.9447 8.09384C17.139 8.09384 19.3745 10.2695 19.3745 13.3823C19.3745 16.8993 17.5984 19.3361 15.2875 19.3361C14.0123 19.3361 13.0566 18.2821 13.3624 16.9869C13.495 16.4285 13.6724 15.8542 13.8449 15.2958C14.1498 14.3086 14.4394 13.3711 14.4394 12.6587C14.4394 11.66 13.9032 10.8272 12.7954 10.8272C11.4894 10.8272 10.4431 12.1762 10.4431 13.9846C10.4431 15.1354 10.8318 15.9144 10.8318 15.9144C10.8318 15.9144 9.54271 21.3612 9.30763 22.3752C9.04643 23.4999 9.14784 25.0779 9.26154 26.1058Z"
      fill={Theme.colors[color]}
    />
  </Svg>
);

export default PinterestIcon;
